// Copyright 2016 Sorama B.V.

export class StreamMeasurementServiceError extends Error {
    public statusCode: number;

    constructor(message: string, statusCode?: number) {
        super(message);
        this.name = "StreamMeasurementServiceError";
        this.statusCode = statusCode;
    }
}
